import React, { useContext } from 'react';

import SneezingFaceUrl from '@pkg/assets/images/sneezing-face.png';
import { Web3AuthContext } from '@pkg/components';
import { DepButton, DepInput, DepInputSize } from '@pkg/components/deprecated';
import { useAppDispatch } from '@pkg/hooks';

import { passwordResetEmail } from '@app/store/actions/auth';

import { Typography } from '../DesignSystem';

import { Container, EmojiImage, FormGroup, FormRow, PrimaryCopySection, Section } from './styles';

export function ForgotPassword() {
    const { authEmail, setAuthEmail, setCurrentStep } = useContext(Web3AuthContext);

    const dispatch = useAppDispatch();

    function handleEmailChange(event) {
        setAuthEmail(event.target.value);
    }

    function handleSendRecoveryLink() {
        dispatch(passwordResetEmail(authEmail));
        setCurrentStep('forgot-password-confirmation');
    }

    return (
        <Container>
            <Section>
                <EmojiImage src={SneezingFaceUrl} />
            </Section>
            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    Forgot my password
                </Typography>
                <Typography type="paragraph" size={18} faded={true}>
                    No worries! Enter the email associated with your account and we&apos;ll send you a recovery link.
                </Typography>
            </PrimaryCopySection>
            <Section>
                <FormGroup>
                    <FormRow>
                        <DepInput
                            label="Email"
                            value={authEmail}
                            onChange={handleEmailChange}
                            sizeVariant={DepInputSize.Compact}
                        />
                    </FormRow>
                    <FormRow>
                        <DepButton variant="glow" disabled={!authEmail} onClick={handleSendRecoveryLink}>
                            Send Recovery Link
                        </DepButton>
                    </FormRow>
                </FormGroup>
            </Section>
        </Container>
    );
}
